import React from "react";

import { ReactComponent as ChevronRight } from "../assets/icons/chevron-right.svg";

// PageHeader's back action — full label from sm, a bare ← on phones so the title keeps one line; the label stays its accessible name
export const PageBackButton = ({ label, onClick }: { label: string; onClick: () => void }) => (
  <button type="button" onClick={onClick} className="eai-btn-outline eai-btn-icon-mobile" aria-label={label} title={label}>
    <ChevronRight aria-hidden="true" className="h-4 w-4 shrink-0 rotate-180 [&_path]:stroke-current sm:hidden" />
    <span className="hidden sm:inline">{label}</span>
  </button>
);
